const template = `
	<div class="results-opts-panel" :class="wide ? 'rop-full-width' : ''">
		<div v-if="unitPicker" class="rop-picker">
			<drop-panel anim="ttb">
				<span class="rop-title">
					<span>{{ ii('UNITS') }}:</span>
					<span class="drop-panel-chosen-text">{{ ii(unitMap[app.query.unit || '']) }}</span>
				</span>
				<items-list slot="box" :items="unitItems" :active-item="activeUnitItem" close-parent="1"></items-list>
			</drop-panel>
		</div>
		<div v-if="avgPicker" class="rop-picker">
			<drop-panel anim="ttb" :static="app.theme === 'silver' || app.theme === 'silver-dark' || app.theme === 'modern'">
				<span class="rop-title">
					<span>{{ ii('VALUES') }}:</span>
					<span class="drop-panel-chosen-text">{{ ii(avgMap[app.query.avg || '']) }}</span>
				</span>
				<items-list slot="box" :items="avgItems" :active-item="activeAvgItem" close-parent="1"></items-list>
			</drop-panel>
		</div>
		<div v-if="timeIntervals" class="rop-intervals">
			<span class="rop-intervals-row">
				<template v-for="item in intervalItems">
					<span v-if="item.disabled">{{ item.label }}</span>
					<router-link
						v-else
						:key="'interval' + item.key"
						:to="item.url"
						:class="item.active ? ' interval-active' : ''"
					>{{ item.text }}</router-link>
				</template>
			</span>
		</div>
	</div>
`;

export default {
	template,
	props: [
		'wide',
		'unit-picker',
		'avg-picker',
		'time-intervals'
	],
	data() {
		return {
			unitMap: {
				'': 'VISITORS',
				hosts: 'HOSTS',
				sessions: 'SESSIONS',
				pageviews: 'PAGEVIEWS'
			},
			avgMap: {
				'': 'Summarized',
				'daily': 'Average daily'
			}
		};
	},
	computed: {
		activeIntervalItem() {
			return this.intervalItems.find(it => it.active);
		},
		intervalItems() {
			let items = [
				//{key: 'hour', text: 'BY_HOURS'},
				{key: undefined, text: 'DAYS', icon: 'calendar-o'},
				{key: 'week', text: 'WEEKS', icon: 'calendar-plus-o'},
				{key: 'month', text: 'MONTHS', icon: 'calendar'},
				{key: 'whole', text: 'WHOLE_PERIOD', icon: 'repeat'}
			];

			let links = items.filter(it => !it.hidden).map(it => {
				it.url = location.pathname + '?' + this.url.queryToString({...this.app.query, timePeriod: it.key});
				it.text = this.ii(it.text);
				it.active = (this.app.query.timePeriod === it.key);
				return it;
			});

			return links;
		},
		activeUnitItem() {
			return this.unitItems.find(it => {
				return it.key === (this.app.query.unit || '');
			});
		},
		unitItems() {
			let links = Object.keys(this.unitMap).map(key => {
				return {
					key: key,
					url: this.getExtendedQueryUrl({unit: key || undefined}),
					text: this.ii(this.unitMap[key || ''])
				};
			});

			return links;
		},
		activeAvgItem() {
			return this.avgItems.find(it => {
				return it.key === (this.app.query.avg || '');
			});
		},
		avgItems() {
			let links = Object.keys(this.avgMap).map(key => {
				return {
					key: key,
					url: this.getExtendedQueryUrl({avg: key || undefined}),
					text: this.ii(this.avgMap[key || ''])
				};
			});

			return links;
		}
	}
};